import React, { useState } from 'react';
import { Sidebar } from './components/Sidebar';
import { Dashboard } from './pages/Dashboard';
export function App() {
  const [activePage, setActivePage] = useState('Dashboard');
  return <div className="flex h-screen w-full overflow-hidden bg-white font-sans" data-id="element-0" data-mp="3k9ukld6f02d4">
      <Sidebar activePage={activePage} onNavigate={setActivePage} data-id="element-1" data-mp="3farfjsqfpw55" />
      <main className="flex-1 overflow-y-auto" data-id="element-2" data-mp="3f8ezxm85fxv9">
        <Dashboard activePage={activePage} data-id="element-3" data-mp="2rk45b0t1quff" />
      </main>
    </div>;
}